//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useEditorState } from '@tiptap/react'

import { Button } from '@tiptap-ui/components/tiptap-ui-primitive/button'
import { LineIcon } from '@tiptap-ui/components/tiptap-icons/line-icon'

export const HorizontalRuleButton = ({ editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => {
      if (!editor) {
        return null
      }

      return {
        isActive: editor.isActive('rule'),
        canInsert: editor.can().chain().setHorizontalRule().run(),
      }
    },
  })

  if (!editor) {
    return null
  }

  return (
    <Button
      type='button'
      disabled={!editorState.canInsert}
      data-style='ghost'
      data-active-state={editorState.isActive ? 'on' : 'off'}
      role='button'
      tabIndex={-1}
      tooltip='Horizontal rule'
      onClick={() => editor.chain().focus().setHorizontalRule().run()}
    >
      <LineIcon className='tiptap-button-icon' />
    </Button>
  )
}

HorizontalRuleButton.propTypes = {
  editor: PropTypes.object.isRequired,
}
